import Analytic from '@commons/cards/analytic'
import Column from '@components/column'
import Grid from '@components/grid'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { Fragment } from 'react'
import Pending from './pending'
import Solved from './solved'

const SupportTickets = () => {
  const items = [
    { label: 'Pending Tickets', component: Pending },
    { label: 'Solved Tickets', component: Solved },
  ]
  return (
    <Fragment>
      <Column>
        {/* <Grid>
          {Array.from({ length: 4 }).map((_, i) => (
            <Analytic key={i}/>
          ))}
        </Grid> */}
        <Title textone="Support" texttwo="Tickets" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default SupportTickets
